<template>
  <div class="resultpage">
    <div class="resultlist">
      <div class="flex">
        <span class="listline"></span>
        <p class="paylisttit">
          <span class="title">{{labInfo.Name}}</span>
        </p>
        <div class="resultlistcon">
          <p>
            <span>申请单号：</span>
            <span>{{labInfo.CheckNo}}</span>
          </p>
          <p>
            <span>申请科室：</span>
            <span>{{labInfo.DptName}}</span>
          </p>
          <p>
            <span>开单医生：</span>
            <span>{{labInfo.DctName}}</span>
          </p>
          <p>
            <span>执行科室：</span>
            <span>{{labInfo.ExecDptName}}</span>
          </p>
          <p>
            <span>报告时间：</span>
            <span>{{labInfo.Time}}</span>
          </p>
        </div>
      </div> 
      <div class="resdeteil">
        <p class="titbg">
          <span>报告名称</span>
          <span>结果值</span>
          <span>参考值</span>
          <span>单位</span>
        </p>
        <div class="wraH">
          <div class="wrapper" ref="wrapper">
            <div class="accurateDae">
              <p v-for="(item,index) in labInfo.Detail" :key="index" v-show="isShow"  :class="item.ResultState==1?'green':(item.ResultState==2?'red':'')">
                <span>{{item.Name}}</span>
                <span>
                  {{item.ItemValue}}
                  <em v-if="item.ResultState==1">↓</em>
                  <em v-if="item.ResultState==2">↑</em>
                  <em></em>
                </span>
                <span>{{item.ItemRange}}</span>
                <span>{{item.ItemUnit}}</span>
              </p>
              <div class="noDate" v-show="!isShow">
                <div v-show="true" class="nolist">
                  <!-- 无数据显示 -->
                  <img src="../../assets/images/searchbg.png" alt class="searchpic">
                  <p class="center">暂无数据</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BScroll from "better-scroll";
import { GetExamPresentation } from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "inspection-result",
  created: function() {
    this.getExamPresentation();
  },
  data() {
    return {
      checkID: this.$route.query.checkID,
      labInfo: [],
      isShow: !true
    };
  },
  mounted() {
    this.$nextTick(() => {
      //$refs绑定元素
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, {
          //开启点击事件 默认为false
          click: true
        });
        // console.log(this.scroll)
      } else if (!this.$refs.wrapper) {
        return;
      } else {
        this.scroll.refresh();
      }
    });
  },
  methods: {
    getExamPresentation() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetExamPresentation(this.checkID).then(response => {
        loading.hide();
        if (response.data.Result) {
          console.info(response.data.Extend);
          this.labInfo = response.data.Extend;
          if (response.data.Extend.Detail.length > 0) {
            this.isShow = true;
          } else {
            this.isShow = false;
          }
        }
      });
    }
  }
};
</script>
<style lang="scss">
.resultpage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.resultpage .resultlist {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: white;
  position: relative;
  padding-bottom: 0.2rem;
  display: flex;
  flex-direction: column;
}

.resultpage .paylisttit {
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #1592e4;
  border-bottom: 0.01rem solid rgba(61, 151, 209, 1);
  height: 0.79rem;
  line-height: 0.8rem;
  padding-left: 0.2rem;
  box-sizing: border-box;
  width: 100%;
}
.resultpage .resultlistcon {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
}
.resultpage .resultlist .resultlistcon > p {
  width: 100%;
  border-bottom: 0.01rem dotted #dddddd;
  height: 0.79rem;
  line-height: 0.8rem;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.resultpage .resultlist .resultlistcon > p:last-child {
  border-bottom: none;
}
.resultpage .resultlist .resultlistcon > p > span:first {
  color: #333333;
  text-align: left;
}
.resultpage .resultlist .resultlistcon > p > span:last-child {
  color: #999999;
  text-align: right;
  float: right;
}
.resultpage .resultlist .paylresultlistconiscon > p:last-child {
  border-bottom: none;
}
.resultpage .listline {
  display: block;
  position: absolute;
  width: 0.08rem;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  top: 0;
  left: 0;
}
.resultpage .resdeteil {
  // height: auto;
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  padding: 0 0.2rem;
  flex: 1;
  overflow: hidden;
}
.resultpage .resdeteil .titbg {
  background: #f2f2f2;
  height: 0.6rem;
  line-height: 0.6rem;
  display: flex;
  flex-direction: row;
  width: 100%;
}
.resultpage .resdeteil .titbg > span {
  flex: 1;
  text-align: center;
}
.resultpage .resdeteil .accurateDae > p {
  display: flex;
  flex-direction: row;
  line-height: 0.43rem;
}
.resultpage .resdeteil .accurateDae > p > span {
  flex: 1;
  text-align: center;
}
.resultpage .resdeteil .wraH {
  height: calc(100% - 0.72rem);
  // height: 100%;
  position: relative;
  border: 0.01rem solid #e3e3e3;
  margin-top: 0.1rem;
}
.wrapper {
  height: 100%;
  overflow: auto;
}
.red{
  color: #FF5B21;
}
.green{
  color: #0AC67A;
}
</style>



// WEBPACK FOOTER //
// src/components/reportquery/inspection-result.vue